import { Controller } from "@hotwired/stimulus"

/**
 * Audio Tag Palette Controller
 *
 * Manages the collapsible audio tag palette for ElevenLabs v3.
 * Inserts [tag] text at cursor position in the linked textarea.
 */
export default class extends Controller {
  static targets = ["panel", "chevron", "toggleButton"]
  static values = { textareaId: String }

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", !this.isOpen)
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = this.isOpen ? "rotate(180deg)" : ""
    }
  }

  insertTag(event) {
    event.preventDefault()
    const tag = event.currentTarget.dataset.tag
    if (!tag) return

    const textarea = document.getElementById(this.textareaIdValue)
    if (!textarea) return

    const tagText = `[${tag}]`
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const before = textarea.value.substring(0, start)
    const after = textarea.value.substring(end)

    // Add space before tag if needed
    const needsSpace = before.length > 0 && !before.endsWith(" ") && !before.endsWith("\n")
    const prefix = needsSpace ? " " : ""
    // Add space after tag only if after text doesn't start with space
    const suffix = after.length === 0 || after.startsWith(" ") || after.startsWith("\n") ? "" : " "

    textarea.value = before + prefix + tagText + suffix + after
    const newPos = start + prefix.length + tagText.length + suffix.length
    textarea.selectionStart = newPos
    textarea.selectionEnd = newPos
    textarea.focus()

    // Trigger input event so other controllers can react
    textarea.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
